import React, { useState } from "react";
import "./FeedbackPage.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function FeedbackPage() {
  const navigate = useNavigate();

  const [feedback, setFeedback] = useState("");
  const maxWords = 500;

  const countWords = (text) => {
    return text.trim() === "" ? 0 : text.trim().split(/\s+/).length;
  };

  return (
    <>
      <div className="feedback-header-row">
        <Link onClick={() => navigate(-1)} className="back-btn2" aria-label="Go back to dashboard">
          <FaArrowLeft className="back-icon" aria-hidden="true" />
          Previous page
        </Link>
        <div className="common-page-header">
          <h1 className="common-page-title">Feedback</h1>
          <p className="common-page-subtitle">
            Please fill out the form below with any feedback you may have
          </p>
        </div>
      </div>
      <main className="feedback-wrapper">
        <div className="feedback-container">


          <div className="feedback-form-group">
            <div className="form-group">
              <label htmlFor="feedback-name">Name</label>
              <input id="feedback-name" type="text" placeholder="Please enter your name" autocomplete="name" />
            </div>

            <div className="form-group">
              <label htmlFor="feedback-email">Email</label>
              <input id="feedback-email" type="email" placeholder="Please enter your email" autocomplete="email" />
            </div>

            <div className="form-group">
              <label htmlFor="feedback-feedback">Feedback</label>
              <textarea
                id="feedback-feedback"
                placeholder="Share your feedback here ......."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <div className="word-counter" role="status" aria-live="polite" aria-atomic="true">
                {countWords(feedback)}/{maxWords} max words
              </div>
            </div>

            <div className="feedback-submit-row">
              <button className="submit-btn" aria-label="Submit feedback">Submit Feedback</button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

